"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconZoomIn = function SvgIconZoomIn(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 48 48",
    "aria-label": "zoom in icon",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Zoom In Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.131 1.999c10.549 0 19.131 8.582 19.131 19.131a18.98 18.98 0 01-2.946 10.174l-.237.365 8.36 8.36a1.91 1.91 0 01.118 2.577l-.118.129-2.705 2.705a1.91 1.91 0 01-2.576.118l-.13-.118-8.358-8.36a19 19 0 01-10.539 3.181C10.582 40.261 2 31.68 2 21.131 2 10.58 10.582 1.998 21.131 1.998zm0 3.826c-8.439 0-15.305 6.866-15.305 15.305s6.866 15.305 15.305 15.305 15.305-6.866 15.305-15.305S29.57 5.825 21.13 5.825zm1.913 7.653v5.739h5.74v3.826h-5.74v5.74h-3.826v-5.74h-5.74v-3.826h5.74v-5.74h3.826z",
    fillRule: "nonzero"
  }));
};

var _default = SvgIconZoomIn;
exports.default = _default;